import script from "./ProductDetailVideoPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailVideoPopup.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailVideoPopup.vue?vue&type=style&index=0&id=207c02aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207c02aa"]])

export default __exports__